<template>
  <v-menu
    v-model="showMenu"
    :position-x="x"
    :position-y="y"
    absolute
    offset-y
    close-on-content-click
    :min-width="200"
    class="v-menu-canvas"
  >
    <template v-slot:activator="{ on }">
      <div class="jsPlumb-canvas-container" @contextmenu="show">
        <slot v-on="on"></slot>
      </div>
    </template>
    <v-list v-if="nodeClicked" dense>
        <v-list-item v-for="(item, index) in items" :key="index" :disabled="shouldShowItem(item)" :style="{ opacity: shouldShowItem(item) ? 0.5 : 1 }">   
          <div>
            <v-list-item @click="callAction(item.action)">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title >{{ item.title }}</v-list-item-title>
            </v-list-item>
          </div>    
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {mapActions, mapState} from "vuex";
import ModaleSavedNodes from "./ModaleSavedNodes.vue"

export default {
  props: {
    nodeClicked: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showMenu: false,
      showTemplate: false,
      x: 0,
      y: 0,
      newNodeX: 0,
      newNodeY: 0,
      items: [
        {
          id: 1,
          title: "Coller",
          icon: "mdi-selection-multiple",
          action: "duplicateSelection",
          showState: true,
          isSaved: true,
        },
        {
          id: 2,
          title: "Add virgin node",
          icon: "mdi-plus",
          action: "createNode",
          showState: true,
          isSaved: true,
        },
        {
          id: 3,
          title: "Add start Node",
          icon: "mdi-plus",
          action: "createStartNode",
          showState: true,
          isSaved: true,
        }
      ]
    };
  },
  components: {
    ModaleSavedNodes,
  },
  created() {
    this.$bus.$on('contextMenuClick', this.handleContextMenuClickEvent);
  },
  mounted (){
    this.checkStartNode();
  },

  watch: {
    // Cette fonction s'exécute chaque fois que `currentNodes` change
    currentNodes: {
      immediate: true,
      handler(newValue) {
        // Vérifiez si newValue (la nouvelle valeur de `currentNodes`) existe
        if (newValue) {
          this.fetchAndPrepareSavedNodes();
        }
      }
    },
    nodeRemoved: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.filterCurrentNodes();
          this.fetchAndPrepareSavedNodes();
          this.$store.commit('SET_NODE_REMOVED', false); // Réinitialiser l'état pour le prochain retrait de nœud.
        }
      }
    }
  },

  computed : {
    ...mapState(['skills']),
    ...mapState('httpNodes', ['currentNodes']),
    ...mapState([
      'nodeRemoved'
    ]),

    createEmptyNode : {
      get() {
        return this.items[0];        
      }
    },
    createStartNode : {
      get() {
        return this.items[1];        
      }
    }
  },

  methods: {
    ...mapActions({
      createNode: "http/nodes/createNode",
      updateNode: "http/nodes/updateNode",
      addNodeToCanvas: "canvas/addNode",
      getSkills: "http/skills/get",
      cloneNode: 'http/nodes/cloneNode',
      duplicateLinks: 'http/links/duplicateLinks',
      createLink: "http/links/createLink",
      getNodesByDialog: "http/nodes/getNodesByDialog"
    }),

    //////////////////////////////////START ADD ITEMS////////////////////////////////////////

    addItems(nodes) {
      const nodeMetas = this.getNodeMetas(nodes);
      this.items = this.shedFirstFewItems(this.items, nodeMetas);
      this.items = this.mergeNodes(this.items, nodeMetas, nodes);
    },

    getNodeMetas(nodes) {
      return nodes.reduce((map, node) => { map[node.name] = node; return map; }, {});
    },

    shedFirstFewItems(items, nodeMetas) {
      return items.filter((item, index) => {
        if (index < 3) {
          return true;
        }
        return !!nodeMetas[item.title];

      });
    },

    mergeNodes(items, nodeMetas, nodes) {
      return nodes.reduce((list, node) => {
        if (!items.find(item => item.title === node.name)) {
          list.push(this.createNodeEntry(node, list));
        }
        return list;
      }, items);
    },

    createNodeEntry(node, items) {
      return {
        id: items.length + 1,
        title: node.name,
        isSaved: node.isSaved,
        icon: "mdi-plus",
        action: node,
      };
    },

    //////////////////////////////////END ADD ITEMS////////////////////////////////////////

    filterAndMapSavedNodes(nodes) {
      return nodes.filter((data) => data.isSaved === true);
    },

    async fetchAndPrepareSavedNodes() {
      let nodes = await this.getNodesByDialog(this.$route.params.id);
      if (nodes.length > 0) {
        this.filterCurrentNodes();
        let savedNodes = this.filterAndMapSavedNodes(nodes);
        if (savedNodes.length > 0) {
          this.addItems(savedNodes);
        }
      }
    },

    filterCurrentNodes() {
      if (this.currentNodes && this.currentNodes[0]) {
        if (!this.currentNodes[0].isSaved) {
          this.items = this.items.filter(item => item.title !== this.currentNodes[0].name);
        }
      }
    },

    checkStartNode() {
      if (this.$route.params.skillId) {
        const promises = this.currentNodes
        Promise.all(promises)
            .then((nodes) => {
              if(nodes.length > 0) {
                nodes.map((node)=> {
                  let anchors = node.anchors.map((anchor)=> anchor.name !== 'in' );
                  this.items[1].showState = !anchors.every(item => item);
                })
              } else {
                this.items[1].showState = true
              }
            })
      }
    },
    show(e) {
      e.preventDefault();
      this.$bus.$emit('contextMenuClick', "contextMenu");
      // console.log(e);
      this.checkStartNode()
      if (this.showMenu === false) {
        this.x = e.clientX;
        this.y = e.clientY;
        this.newNodeX = e.offsetX;
        this.newNodeY = e.offsetY;
      }
      this.showMenu = false;
     /* this.$nextTick(() => {
        this.showMenu = true;
        this.x = e.clientX;
        this.y = e.clientY;
        this.newNodeX = e.offsetX;
        this.newNodeY = e.offsetY;
      });*/
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    // Function to find a new anchor based on value, name, and variable
    // findNewAnchor(oldAnchor, newAnchorsMap) {
    //   return Array.from(newAnchorsMap.values()).find(newAnchor => {
    //     return (
    //       oldAnchor.value === newAnchor.value &&
    //       oldAnchor.name === newAnchor.name &&
    //       oldAnchor.variable === newAnchor.variable
    //     );
    //   });
    // },
    async callAction(action) {
      const defaultAddNodeData = {
        position: {
          x: this.newNodeX,
          y: this.newNodeY,
        },
        startNode: false
      };

      const defaultAddStartNodeData = {
        position: {
          x: this.newNodeX,
          y: this.newNodeY,
        },
        startNode: true
      };

      if (action === "createNode") {
        this.createNode({
          skillId: this.$route.params.skillId,
          data: defaultAddNodeData,
          startNode: false
        }).then((data) => {
          return this.addNodeToCanvas(data);
        });
      } else if(action === "createStartNode"){
        this.createNode({
          skillId: this.$route.params.skillId,
          data: defaultAddStartNodeData,
        }).then((data) => {
          this.items[1].showState = false;
          return this.addNodeToCanvas(data);
        });

      } else if (action === "duplicateSelection") {
        // Retrieve the array of selected nodes from localStorage
        let selectedNodes = [];
        const storedNodes = localStorage.getItem('selectedNodes');
        //const duplicateSelectionBool = localStorage.getItem("duplicateSelectionBool") || false;

        if (storedNodes) {
          try {
            selectedNodes = JSON.parse(storedNodes);
          } catch (error) {
            console.error('Error parsing stored nodes:', error);
          }
        }

        if (selectedNodes.length > 0) {
          const uniqueLinksSet = new Set();

          // Create a map of anchors using their IDs
          const anchorsMap = new Map();
          selectedNodes.forEach(element => {
            element.node.anchors.forEach(anchor => {
              anchorsMap.set(anchor._id, anchor);
            });
          });

          // Clone the first node and add it to the canvas
          let newNodes = [];
          const cloneAndAddToCanvas = async (element, position) => {
            const clonedNode = await this.cloneNode({ skillId: this.$route.params.skillId, idNode: element.nodeId, data: { position: position} })
              .then(data => {
                newNodes.push(data);
                data.position.x = this.newNodeX;
                data.position.y = this.newNodeY;
                return data;
              })
              .catch(() => {
                console.log("Error duplicating Node : ", element.node);
              });

            if (clonedNode) {
              await this.addNodeToCanvas(clonedNode);

              // Get the anchors of the cloned node and add them to the anchorsMap
              clonedNode.anchors.forEach(anchor => {
                anchorsMap.set(anchor._id, anchor);
              });
            }
          };

          // Clone the first node
          await cloneAndAddToCanvas(selectedNodes[0], { x: this.newNodeX, y: this.newNodeY });
          if(selectedNodes.length === 1) {
            localStorage.removeItem("duplicateSelectionBool");
            localStorage.removeItem("selectedNodes");
            window.location.reload();
          }

          // Continue cloning for the rest of the nodes
          for (let i = 1; i < selectedNodes.length; i++) {
            await cloneAndAddToCanvas(selectedNodes[i], { x: this.newNodeX + (selectedNodes[i].node.position.x - selectedNodes[0].node.position.x), y: this.newNodeY + (selectedNodes[i].node.position.y - selectedNodes[0].node.position.y) });
          }

          // Log unique links for each node
          selectedNodes.forEach(element => {
            element.links.forEach(link => {
              const fromAnchor = anchorsMap.get(link.from);
              const toAnchor = anchorsMap.get(link.to);

              // Check if both fromAnchor and toAnchor exist
              if (fromAnchor && toAnchor) {
                const linkString = JSON.stringify({
                  from: fromAnchor,
                  to: toAnchor,
                });
                uniqueLinksSet.add(linkString);
              }
            });
          });

          const uniqueLinksArray = Array.from(uniqueLinksSet).map(linkString => JSON.parse(linkString));

          // Map old anchors to new anchors
          const newAnchorsMap = new Map();
          newNodes.forEach(node => {
            node.anchors.forEach(anchor => {
              newAnchorsMap.set(anchor._id, anchor);
            });
          });

          await this.duplicateLinks({newNodes: newNodes, uniqueLinksArray: uniqueLinksArray, selectedNodes: selectedNodes})
          .then(data => {
            data.forEach(async link => {
              await this.createLink({
                from: link.from[0]._id,
                to: link.to[0]._id,
                skill: this.$route.params.skillId
              }).then(() => {
                window.location.reload();
              })
              .catch(error => {
                console.log(error);
              })
            })
          })
          .catch(error => {
            console.log(error);
          })
        }

        localStorage.removeItem("duplicateSelectionBool");
        localStorage.removeItem("selectedNodes");

      } else {
        const clonnedNode = await this.cloneNode({ skillId: this.$route.params.skillId, idNode: action._id, data: { position: defaultAddStartNodeData.position } })
        if(clonnedNode) {
          await this.addNodeToCanvas(clonnedNode);
        }
        // .then((data) => {
        //   data.position.x = defaultAddNodeData.position.x;
        //   data.position.y = defaultAddNodeData.position.y;
        //   return data;
        // })
        // .then((data) => {
        //   this.updateNode({ skillId: this.$route.params.skillId, idNode: data._id, data: data })
        //   .then((data) => {
        //     return this.addNodeToCanvas(data);
        //   })
        // });
      }
    },
    shouldShowItem(item) {
      if (item.action === "duplicateSelection") {
        const selectedNodes = JSON.parse(localStorage.getItem("selectedNodes")) || [];

        return selectedNodes.length === 0;
      }
      // If showState is not defined or false, always show the item
      return false;
    },

    handleContextMenuClickEvent(eventSource) {
      if(eventSource !== "contextMenu") {
        this.showMenu = false;
      }
    },

  },
};
</script>

<style scoped>
.jsPlumb-canvas-container {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  outline: none;
  overflow: hidden;
  max-height: 100vh;
  max-width: 100vw;
}
</style>
